import { api } from '../api';

export type ExportFormat = 'xlsx' | 'csv' | 'pdf';

/**
 * 백엔드 export 엔드포인트에서 파일을 받아 브라우저 다운로드를 트리거.
 * Content-Disposition 헤더의 filename*=UTF-8''... 값을 우선 사용해
 * 한글 파일명을 정확히 복원한다.
 */
export async function downloadExport(url: string, fallbackFilename: string): Promise<void> {
  const res = await api.get(url, { responseType: 'blob' });
  const filename = parseFilename(res.headers['content-disposition']) ?? fallbackFilename;
  const blobUrl = URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

function parseFilename(header: string | undefined): string | null {
  if (!header) return null;
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8?.[1]) {
    try {
      return decodeURIComponent(utf8[1]);
    } catch {
      // fall through
    }
  }
  const ascii = /filename="([^"]+)"/i.exec(header);
  return ascii?.[1] ?? null;
}
